
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/copywriting/extract-seo-optimized-text",
      function () {
        return require("private-next-pages/copywriting/extract-seo-optimized-text.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/copywriting/extract-seo-optimized-text"])
      });
    }
  